import AuthorV3 from "../authorv3";
import ChapterPreview from "../chapter-preview";
import Ctav4Copy from "../ctav4Copy";
import Footer from "../global/footer";
import Header from "../global/header";
import Hero from "../hero";
import Cta from "../cta";

const Version01 = ({header, footer}) => {
  const {menu} = footer;

  return (
    <>
      <Header header={header} />
      <Hero isBg="yes" />
      <ChapterPreview isBg="" />
      <Ctav4Copy isBg="" />
      <AuthorV3 isBg="" />
      {/* <Cta isBg="yes" /> */}
      <Footer isBg="yes" menu={menu} />
    </>
  );
};

export default Version01;
